<template>
    <section :class="'page-section section-content-with-photo ' ">
        <div class="container-fluid">

            <div class="block-wrapper">
                <div class="image-wrapper">
                    <img :src="contentPhoto_image" alt="">
                </div>

                <div class="content-wrapper" style="text-align: left;">
                    <h2>
                        <div v-safe-html="contentPhoto_title" style="font-size: 22px;"/>
                    </h2>
                    <div v-safe-html="contentPhoto_content1"  style="font-size: 20px;"/>
                    <div v-safe-html="contentPhoto_content2" />
                </div>
            </div>

        </div>
    </section>
</template>
  
<script>
export default {
    props: {
    contentPhoto_image: String,
    contentPhoto_title: String,
    contentPhoto_content1: String,
    contentPhoto_content2: String,

  },
    data() {
        return {

            image: require('@/assets/404.jpg'),
        };
    }
};
</script>
  
<style>
@import '@/css/contentWithPhotoSection.css';

.page-section.section-content-with-photo {
   display: flex;
   justify-content:space-between;
  }
</style>